/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { routePrefix } from '../app/App';
import { PageDTO } from '../dto/PageDTO';
import { parseLinkHeader } from '../components/QueryBuilder';
import { fetchMediaResistances } from '../features/media-resistance/MediaResistanceSlice';
import { buildMediaResistanceQuery } from '../features/media-resistance/MediaResistance';
import { ParametersMediaResistance } from '../interfaces/index';
import { Dispatch } from '@reduxjs/toolkit';

export const PDF_CONTENT_TYPE = 'application/pdf';
export async function getMediaResistances(query: string, pageUrl?: string): Promise<PageDTO> {
  if (pageUrl && pageUrl.includes('?')) {
    query = pageUrl.split('?')[1];
    query = '?' + query;
  }
  const url = `${routePrefix()}media-resistances${query}`;
  const response = await axios.get(url);

  let result: PageDTO;

  if (response.headers['link']) {
    const linkArray = parseLinkHeader(response.headers['link']);

    result = {
      next: linkArray['next'],
      first: linkArray['first'],
      previous: linkArray['prev'],
      last: linkArray['last'],
      total: response.headers['x-total-count'],
      data: response.data,
    };
  } else {
    result = { next: '', first: '', previous: '', last: '', total: response.data.length, data: response.data };
  }
  return result;
}

export async function getMediaResistancesPdf(query: string): Promise<any> {
  const url = `${routePrefix()}media-resistances${query}`;
  const response = await axios.get(url, {
    data: {},
    headers: {
      'content-type': PDF_CONTENT_TYPE,
    },
    responseType: 'blob',
  });

  console.log(response, 'RESPONSE');

  return response;
}

export function getCompleteMediaResistances(
  parameters: ParametersMediaResistance,
  resistanceType: string[],
  dispatch: Dispatch<any>,
): void {
  const query = buildMediaResistanceQuery(parameters, resistanceType);
  dispatch(fetchMediaResistances(query, true));
}
